import { useTheme } from '@mui/material';
const useAlertDetailStyles = () => {
    const theme = useTheme();
    const HeaderHeight = '48px';
    const BottomNavigationHeight = '56px';
    return {
        AlertDetailSection: {
            display: 'flex',
            flexDirection: 'column !important',
            p: 2,
            height: `calc(100dvh - ${HeaderHeight} - ${BottomNavigationHeight})`,
            overflowY: 'auto'
        },
        LocationContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            pt: 2,
            pb: 1
        },
        ViewMap: {
            color: theme.palette.info.dark
        },
        LocationLeftSection: {
            flex: 1
        },
        MediaContainer: {
            mt: '20px'
        }
    };
};
export default useAlertDetailStyles;
